import { type ColumnState } from '@ag-grid-community/core';

export class GridConfig {
  public name!: string;
  public filters?: any;
  public sorting?: ColumnState[];
  public pageNumber?: number;
}
